import React, { useEffect, useState } from "react";
const MirumFormikErrorMsg = ({ formik, formikKey, className, name }) => {
  const [hasError, setHasError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  useEffect(() => {
    console.log(
      "formik.errors: ",
      formik.errors[formikKey],
      formik.touched[formikKey],
      formik.errors,
      formikKey
    );
    if (formik.errors[formikKey]) {
      setHasError(true);
      setErrorMsg(formik.errors[formikKey]);
    } else {
      setHasError(false);
    }
  }, [formik?.errors, formikKey]);

  return (
    <div>
      {hasError ? (
        <p className="text-black text-[var(--orange)]">{errorMsg}</p>
      ) : null}
      {/* <br /> */}
      {/* {formik.values[formikKey]} */}
    </div>
  );
};
export default MirumFormikErrorMsg;
